export default __webpack_public_path__ + "static/media/icon-his-icons-trash.b9f47db9.svg";